import { render, staticRenderFns } from "./BrokerageLogin.vue?vue&type=template&id=3309764e&"
import script from "./BrokerageLogin.vue?vue&type=script&lang=js&"
export * from "./BrokerageLogin.vue?vue&type=script&lang=js&"
import style0 from "./BrokerageLogin.vue?vue&type=style&index=0&id=3309764e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports